export function clickEvent() {
  const clickElements = [].slice.call(document.getElementsByClassName('js-click-event'))

  if (clickElements.length === 0) return

  clickElements.forEach((el: HTMLElement) => {
    el.addEventListener('click', (e) => {
      const target = e.currentTarget as HTMLAnchorElement
      const clickValue = target.dataset.value
      const clickHref = target.getAttribute('href')
      window.gtag('event', 'click', { event_label: 'js_rel', event_value: clickValue, custom1: clickHref })
    })
  })
}

export function clickUxCv() {
  const clickElements = [].slice.call(document.getElementsByClassName('js-ux-cv'))

  if (clickElements.length === 0) return

  let isFirstUxCv = true
  clickElements.forEach((el: HTMLElement) => {
    el.addEventListener(
      'click',
      (e) => {
        if (!isFirstUxCv) return
        const target = e.currentTarget as HTMLElement
        const cvButtonType = target.classList.contains('js-ux-cv-keep') ? 'keep' : 'entry'
        const cvCurrentWork = target.dataset.uxCvCurrent === '1' ? '1' : ''
        const componentName = target.dataset.component
        window.gtag('event', 'click', { event_label: 'ux-cv', event_element: cvButtonType, custom1: cvCurrentWork, custom2: componentName })
        isFirstUxCv = false
      },
      { once: true }
    )
  })
}
